import Vue from 'vue'
import LocationFinder from './LocationFinder.vue'

Array.from(document.querySelectorAll('[data-app="location-finder"]')).forEach(el => {
  const defaultLocation = el.getAttribute('data-default-location')
  const app = new Vue({
    el,
    data() {
      return {
        defaultLocation,
      }
    },
    components: { LocationFinder },
    template: '<LocationFinder :default-location="defaultLocation" />'
  })
})
